import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const MODAL_BODY_PADDING = 20;

export const ModalFooter = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery('(max-width: 48em)', undefined, {
    getInitialValueInEffect: false
  });

  if (!isMobile) {
    return <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>{children}</Box>;
  }

  return (
    <Box
      className="modal-footer-mobile"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 1,
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        gap: 12,
        marginInline: -MODAL_BODY_PADDING,
        padding: `12px ${MODAL_BODY_PADDING}px calc(12px + env(safe-area-inset-bottom))`,
        backgroundColor: 'var(--color-bg-surface)',
        borderTop: '1px solid var(--color-border-soft)'
      }}
    >
      {children}
    </Box>
  );
};
